/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Email_Settings_Save_FailedInputs */

const en_admin_email_settings_save_failed = /** @type {(inputs: Admin_Email_Settings_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving failed`)
};

const de_admin_email_settings_save_failed = /** @type {(inputs: Admin_Email_Settings_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern fehlgeschlagen.`)
};

/**
* | output |
* | --- |
* | "Saving failed" |
*
* @param {Admin_Email_Settings_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_email_settings_save_failed = /** @type {((inputs?: Admin_Email_Settings_Save_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Email_Settings_Save_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_email_settings_save_failed(inputs)
	return en_admin_email_settings_save_failed(inputs)
});